import { render, staticRenderFns } from "./readonlyformgroup.vue?vue&type=template&id=54548fc5"
import script from "./readonlyformgroup.js?vue&type=script&lang=js&external"
export * from "./readonlyformgroup.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports